const group = (name, ...areaCodes) => ({
    name,
    areaCodes: areaCodes,
});
export const US_AREA_CODE_GROUPS = [
    group("Seattle, WA", "206", "425", "253", "360"),
    group("Portland, OR", "503", "971"),
    group("San Francisco / Marin, CA", "415", "628"),
    group("Oakland / East Bay, CA", "510", "341"),
    group("San Jose / South Bay, CA", "408", "669"),
    group("Sacramento, CA", "916", "279"),
    group("Los Angeles (Central), CA", "213", "323"),
    group("Los Angeles (Westside), CA", "310", "424"),
    group("Los Angeles (San Fernando Valley), CA", "818", "747"),
    group("Orange County (North), CA", "714", "657"),
    group("San Diego, CA", "619", "858"),
    group("Las Vegas, NV", "702", "725"),
    group("Denver, CO", "303", "720"),
    group("Salt Lake City, UT", "801", "385"),
    group("Boise, ID", "208", "986"),
    group("Dallas, TX", "214", "469", "972", "945"),
    group("Fort Worth, TX", "817", "682"),
    group("Houston, TX", "713", "281", "832", "346"),
    group("Austin, TX", "512", "737"),
    group("San Antonio, TX", "210", "726"),
    group("Chicago (Downtown / City), IL", "312", "872", "773"),
    group("Detroit, MI", "313", "679"),
    group("Minneapolis / St. Paul, MN", "612", "651", "763", "952"),
    group("Milwaukee, WI", "414", "262"),
    group("St. Louis, MO", "314", "636"),
    group("Indianapolis, IN", "317", "463"),
    group("Columbus, OH", "614", "380"),
    group("Cleveland, OH", "216", "440"),
    group("Cincinnati, OH", "513", "283"),
    group("Omaha, NE", "402", "531"),
    group("Atlanta, GA", "404", "678", "470", "770"),
    group("Miami, FL", "305", "786"),
    group("Fort Lauderdale, FL", "954", "754"),
    group("Orlando, FL", "407", "321", "689"),
    group("Tampa / St. Petersburg, FL", "813", "727"),
    group("Nashville, TN", "615", "629"),
    group("Birmingham, AL", "205", "659"),
    group("Charlotte, NC", "704", "980"),
    group("Raleigh-Durham, NC", "919", "984"),
    group("Greensboro, NC", "336", "743"),
    group("Richmond, VA", "804", "686"),
    group("Oklahoma City, OK", "405", "572"),
    group("Tulsa, OK", "918", "539"),
    group("Jackson, MS", "601", "769"),
    group("New York City (Manhattan), NY", "212", "646", "332", "917"),
    group("New York City (Outer Boroughs), NY", "718", "347", "929"),
    group("Long Island, NY", "516", "631", "934"),
    group("Syracuse, NY", "315", "680"),
    group("Boston (City), MA", "617", "857"),
    group("Boston (Route 128 Suburbs), MA", "781", "339"),
    group("Worcester / Central MA", "508", "774"),
    group("Philadelphia, PA", "215", "267", "445"),
    group("Pittsburgh, PA", "412", "878"),
    group("Baltimore, MD", "410", "443", "667"),
    group("Washington DC (VA Suburbs)", "703", "571"),
    group("Washington DC (MD Suburbs)", "301", "240"),
    group("Hartford, CT", "860", "959"),
    group("New Haven, CT", "203", "475"),
];
export const getAreaCodeSuggestions = (areaCode) => {
    const related = [];
    const seen = new Set();
    let metroName = null;
    for (const entry of US_AREA_CODE_GROUPS) {
        if (!entry.areaCodes.includes(areaCode)) {
            continue;
        }
        if (metroName === null) {
            metroName = entry.name;
        }
        for (const code of entry.areaCodes) {
            if (code !== areaCode && !seen.has(code)) {
                seen.add(code);
                related.push(code);
            }
        }
    }
    if (metroName === null || related.length === 0) {
        return null;
    }
    return { metroName, relatedAreaCodes: related };
};
//# sourceMappingURL=area-code-groups.js.map